
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Company extends Vue {
  @Prop({ type: String, required: true }) readonly icon!: string;
}
